import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { ECG_ITEMS_PER_PAGE } from '../clients/ecg.client';
import {
  selectAll,
  selectEntities,
  selectTotal,
} from '../reducers/ecg-list.reducer';

export const ecgListSelector = ({ ecgList }: DefaultRootState) => ecgList;

export const ecgItemsSelector = createSelector(ecgListSelector, selectAll);

export const ecgEntitiesSelector = createSelector(
  ecgListSelector,
  selectEntities,
);

export const totalSelector = createSelector(ecgListSelector, selectTotal);

export const currentPageSelector = createSelector(totalSelector, (total) =>
  Math.ceil(total / ECG_ITEMS_PER_PAGE),
);

export const currentIndexSelector = createSelector(
  ecgListSelector,
  ({ currentIndex }) => currentIndex,
);

export const currentItemSelector = createSelector(
  ecgItemsSelector,
  currentIndexSelector,
  (items, index) => items[index] ?? null,
);

export const bufferedIndexSelector = createSelector(
  currentIndexSelector,
  (index) => index + ECG_ITEMS_PER_PAGE / 4,
);

export const bufferedItemSelector = createSelector(
  ecgItemsSelector,
  bufferedIndexSelector,
  (items, index) => items[index] ?? null,
);

export const doneSelector = createSelector(ecgListSelector, ({ done }) => done);
